import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const { resetPassword } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setError('');
      setMessage('');
      setLoading(true);
      await resetPassword(email);
      setMessage('Check your email for password reset instructions');
      setEmail(''); // Clear the email field after successful submission
    } catch (error) {
      setError(error.message);
      console.error('Password reset error:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-page dark:bg-page-dark">
      <div className="max-w-md w-full mx-4 p-8 rounded-lg shadow-lg bg-surface dark:bg-surface-dark">
        <h2 className="text-2xl font-bold mb-6 text-center text-text-primary dark:text-text-primary-dark">
          Reset Password
        </h2>

        {error && (
          <div className="mb-4 p-3 rounded-lg bg-status-error-bg dark:bg-status-error-bg-dark text-status-error-text dark:text-status-error-text-dark">
            {error}
          </div>
        )}

        {message && (
          <div className="mb-4 p-3 rounded-lg bg-status-success-bg dark:bg-status-success-bg-dark text-status-success-text dark:text-status-success-text-dark">
            {message}
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium mb-1 text-text-secondary dark:text-text-secondary-dark">
              Email Address
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full p-3 rounded-lg bg-input-bg dark:bg-input-bg-dark text-text-primary dark:text-text-primary-dark border-input-border dark:border-input-border-dark focus:ring-2 focus:ring-button focus:border-transparent"
              required
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full p-3 rounded-lg bg-button hover:bg-button-hover dark:bg-button-dark dark:hover:bg-button-hover-dark text-text-primary-dark transition-colors disabled:opacity-50"
          >
            {loading ? 'Sending...' : 'Reset Password'}
          </button>
        </form>

        <div className="mt-4 text-center space-y-2">
          <p className="text-text-tertiary dark:text-text-tertiary-dark">
            Remember your password?{' '}
            <Link to="/login" className="text-text-link dark:text-text-link-dark hover:text-text-link-hover dark:hover:text-text-link-hover-dark">
              Sign in
            </Link>
          </p>
          <p className="text-text-tertiary dark:text-text-tertiary-dark">
            Don't have an account?{' '}
            <Link to="/signup" className="text-text-link dark:text-text-link-dark hover:text-text-link-hover dark:hover:text-text-link-hover-dark">
              Sign up
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword; 